/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { CorrectionResolution } from './CorrectionResolution';
import {
    CorrectionResolutionFromJSON,
    CorrectionResolutionFromJSONTyped,
    CorrectionResolutionToJSON,
    CorrectionResolutionToJSONTyped,
} from './CorrectionResolution';
import type { CorrectionSource } from './CorrectionSource';
import {
    CorrectionSourceFromJSON,
    CorrectionSourceFromJSONTyped,
    CorrectionSourceToJSON,
    CorrectionSourceToJSONTyped,
} from './CorrectionSource';
import type { Verdict } from './Verdict';
import {
    VerdictFromJSON,
    VerdictFromJSONTyped,
    VerdictToJSON,
    VerdictToJSONTyped,
} from './Verdict';

/**
 * 
 * @export
 * @interface CorrectionSchema
 */
export interface CorrectionSchema {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    receivedAt: Date;
    /**
     * 
     */
    originMessageSid: string | null;
    /**
     * 
     */
    source: CorrectionSource;
    /**
     * 
     */
    enteredBy: string | null;
    /**
     * 
     */
    rawText: string | null;
    /**
     * 
     */
    resolution: CorrectionResolution;
    /**
     * 
     */
    confirmText: string | null;
    /**
     * 
     */
    isFeedback: boolean | null;
    /**
     * 
     */
    lengthMm: number | null;
    /**
     * 
     */
    girthMm: number | null;
    /**
     * 
     */
    weightG: number | null;
    /**
     * 
     */
    species: string | null;
    /**
     * 
     */
    speciesScientific: string | null;
    /**
     * 
     */
    note: string | null;
    /**
     * 
     */
    verdict: Verdict | null;
    /**
     * 
     */
    reaction: string | null;
    /**
     * 
     */
    promptContext: string | null;
}



/**
 * Check if a given object implements the CorrectionSchema interface.
 */
export function instanceOfCorrectionSchema(value: object): value is CorrectionSchema {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('receivedAt' in (value as Record<string, any>)) && !('received_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['receivedAt'] === undefined && (value as Record<string, any>)['received_at'] === undefined)) return false;
    if ((!('originMessageSid' in (value as Record<string, any>)) && !('origin_message_sid' in (value as Record<string, any>))) || ((value as Record<string, any>)['originMessageSid'] === undefined && (value as Record<string, any>)['origin_message_sid'] === undefined)) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if ((!('enteredBy' in (value as Record<string, any>)) && !('entered_by' in (value as Record<string, any>))) || ((value as Record<string, any>)['enteredBy'] === undefined && (value as Record<string, any>)['entered_by'] === undefined)) return false;
    if ((!('rawText' in (value as Record<string, any>)) && !('raw_text' in (value as Record<string, any>))) || ((value as Record<string, any>)['rawText'] === undefined && (value as Record<string, any>)['raw_text'] === undefined)) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if ((!('confirmText' in (value as Record<string, any>)) && !('confirm_text' in (value as Record<string, any>))) || ((value as Record<string, any>)['confirmText'] === undefined && (value as Record<string, any>)['confirm_text'] === undefined)) return false;
    if ((!('isFeedback' in (value as Record<string, any>)) && !('is_feedback' in (value as Record<string, any>))) || ((value as Record<string, any>)['isFeedback'] === undefined && (value as Record<string, any>)['is_feedback'] === undefined)) return false;
    if ((!('lengthMm' in (value as Record<string, any>)) && !('length_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMm'] === undefined && (value as Record<string, any>)['length_mm'] === undefined)) return false;
    if ((!('girthMm' in (value as Record<string, any>)) && !('girth_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['girthMm'] === undefined && (value as Record<string, any>)['girth_mm'] === undefined)) return false;
    if ((!('weightG' in (value as Record<string, any>)) && !('weight_g' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightG'] === undefined && (value as Record<string, any>)['weight_g'] === undefined)) return false;
    if (!('species' in value) || value['species'] === undefined) return false;
    if ((!('speciesScientific' in (value as Record<string, any>)) && !('species_scientific' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesScientific'] === undefined && (value as Record<string, any>)['species_scientific'] === undefined)) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('verdict' in value) || value['verdict'] === undefined) return false;
    if (!('reaction' in value) || value['reaction'] === undefined) return false;
    if ((!('promptContext' in (value as Record<string, any>)) && !('prompt_context' in (value as Record<string, any>))) || ((value as Record<string, any>)['promptContext'] === undefined && (value as Record<string, any>)['prompt_context'] === undefined)) return false;
    return true;
}

export function CorrectionSchemaFromJSON(json: any): CorrectionSchema {
    return CorrectionSchemaFromJSONTyped(json, false);
}

export function CorrectionSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectionSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'receivedAt': (json['received_at'] == null ? json['received_at'] : parseDateTime(json['received_at'])),
        'originMessageSid': json['origin_message_sid'],
        'source': CorrectionSourceFromJSON(json['source']),
        'enteredBy': json['entered_by'],
        'rawText': json['raw_text'],
        'resolution': CorrectionResolutionFromJSON(json['resolution']),
        'confirmText': json['confirm_text'],
        'isFeedback': json['is_feedback'],
        'lengthMm': json['length_mm'],
        'girthMm': json['girth_mm'],
        'weightG': json['weight_g'],
        'species': json['species'],
        'speciesScientific': json['species_scientific'],
        'note': json['note'],
        'verdict': VerdictFromJSON(json['verdict']),
        'reaction': json['reaction'],
        'promptContext': json['prompt_context'],
    };
}

export function CorrectionSchemaToJSON(json: any): CorrectionSchema {
    return CorrectionSchemaToJSONTyped(json, false);
}

export function CorrectionSchemaToJSONTyped(value?: CorrectionSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'received_at': value['receivedAt'] == null ? value['receivedAt'] : serializeDateTime(value['receivedAt']),
        'origin_message_sid': value['originMessageSid'],
        'source': CorrectionSourceToJSON(value['source']),
        'entered_by': value['enteredBy'],
        'raw_text': value['rawText'],
        'resolution': CorrectionResolutionToJSON(value['resolution']),
        'confirm_text': value['confirmText'],
        'is_feedback': value['isFeedback'],
        'length_mm': value['lengthMm'],
        'girth_mm': value['girthMm'],
        'weight_g': value['weightG'],
        'species': value['species'],
        'species_scientific': value['speciesScientific'],
        'note': value['note'],
        'verdict': VerdictToJSON(value['verdict']),
        'reaction': value['reaction'],
        'prompt_context': value['promptContext'],
    };
}

